import styled from "styled-components";
import { lighten } from "polished";

export const DropdownOpener = styled.div`
    margin-top: 2px;
    padding: 4px;
    cursor: pointer;
    position: relative;

    svg {
        display: block;
        fill: ${p => p.theme.c.grey7};
        transition: 300ms;
    }

    &:hover {
        svg {
            fill: ${p => p.theme.c.active};
        }
    }

    [class^="i-"] {
        font-size: 18px;
        transform: scale(1.2) translateY(2px);
        display: inline-block;
        margin-right: 8px;
    }
`;

export const StyledDropdown = styled.div`
    position: absolute;
    top: calc(100% - 2px);
    right: 1px;
    z-index: 3;
    background-color: ${p => p.theme.c.cardBackground};
    min-width: 230px;
    font-size: 18px;
    font-weight: 300;
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);
    opacity: 0;
    pointer-events: none;
    transition: 180ms;
    transform: scale(0.85);
    transform-origin: top right;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid ${p => p.theme.mode === "dark" ? p.theme.c.greyA : p.theme.c.disabled};

    &.Show {
        opacity: 1;
        pointer-events: all;
        transform: scale(1);
    }
    > div,
    > a {
        display: block;
        border-bottom: 1px solid ${p => p.theme.mode === "dark" ? p.theme.c.greyA : p.theme.c.disabled};
        padding: 6px 10px;

        &:last-child {
            border-bottom: 0;
        }

        &:hover {
            background-color: ${p => p.theme.c.active};
            color: ${p => p.theme.c.whiteOnActive};
        }
    }

    .Disabled {
        cursor: default;
        background-color: ${p => lighten(0.12, p.theme.c.disabled)};
        &:hover {
            background-color: ${p => lighten(0.12, p.theme.c.disabled)};
            color: ${p => p.theme.c.dark};
        }
    }
`;
